import { takeEvery, put, select } from 'redux-saga/effects';
import pick from 'lodash/pick';
import restaurantsListActions from '../actionTypes/restaurantsActions';
import { API_CALL } from '../actionTypes/sharedActions';
import { GET_RESTAURANTS, DELETE_RESTAURANT } from '../routes';


const getFilters = (state) => pick(state.restaurantsReducer, ['per', 'page', 'query']);

function* getRestaurantsList() {
  const filters = yield select(getFilters);
  yield put({
    type: API_CALL,
    payload: {
      url: GET_RESTAURANTS,
      method: 'POST',
      data: { per: 10, page: 1, ...filters },
    },
    successAction: restaurantsListActions.getRestaurantsListSuccess,
    failureAction: restaurantsListActions.getRestaurantsListFailed,
  });
}

function* deleteRestaurant({ payload }) {
  const { id } = payload;

  yield put({
    type: API_CALL,
    payload: {
      url: DELETE_RESTAURANT.replace(':id', id),
      method: 'DELETE',
      data: payload,
    },
    successAction: restaurantsListActions.deleteRestaurantSuccess,
    failureAction: restaurantsListActions.deleteRestaurantFailed,
  });
}

export default function* watchRestaurantsList() {
  yield takeEvery(restaurantsListActions.getRestaurantsList, getRestaurantsList);
  yield takeEvery(restaurantsListActions.addNewRestaurantSuccess, getRestaurantsList);
  yield takeEvery(
    restaurantsListActions.updateRestaurantDetailsSuccess,
    getRestaurantsList,
  );

  yield takeEvery(
    restaurantsListActions.deleteRestaurant,
    deleteRestaurant,
  );
  yield takeEvery(
    restaurantsListActions.deleteRestaurantSuccess,
    getRestaurantsList,
  );
}
